import React, { useState, useEffect } from "react";
import { Row, Col, Form } from "react-bootstrap";
//action
import * as actions from "Store/Course/Instructor/OtherLabs/Actions";
import "../../css/Options.scss";
import log from "loglevel";


const Option = ({
  courseId,
  question,
  otherLabID,
  questionId,
  option,
  questionType,
  previousResponse,
  setQRId,
  qrId,
  updateResponse,
  disable,
  Eval
}) => {

  const { id, text } = option; // Option ID and Option Text
  // const [check, setCheck] = useState(previousResponse.response_options ? previousResponse.response_options.find(item => item.id === id) : false);
  const [check, setCheck] = useState((previousResponse?.response_options_ids?.includes(id)) || false);
  //const [check,setCheck]=useState(false)

  log.log(id, check, previousResponse.response_options_ids, "checkk");
  log.log(previousResponse.response_options_ids?.includes(id), id, "checkk extra");

  useEffect(() => {
    log.log("check:", check);
  }, [check]);

  useEffect(() => {
    log.log("response_options_ids:", previousResponse.response_options_ids);
    setCheck((previousResponse?.response_options_ids?.includes(id) || false))
  }, [previousResponse.response_options_ids]);

  const answerOptions = question.questionanswer_set?.map(answer => answer.answer_option);

  useEffect(() => {
    log.log({ qrId });
  }, [qrId]);

  const storeResponses = async (id) => {
    log.log("clicked on options", { questionType }, { id }, { previousResponse }, { qrId });

    let updatedResponseOptions = [];
    let updatedResponseOptionsIds = [];

    if (questionType === "S") {
      const response = await actions.addQuestionResponsesRequest(courseId, question, id, null, qrId, null);
      if (response) {
        setQRId(response.id);
      }
      log.log('prevResponse for S question', { previousResponse }, { response }, { id }, response.id, { qrId });
      updatedResponseOptions = [id];
      updatedResponseOptionsIds = [id];
      const update_resp = { ...previousResponse, response_options: updatedResponseOptions, response_options_ids: updatedResponseOptionsIds, id: question?.id }
      updateResponse(update_resp);
    } else if (questionType === "M") {
      // Toggle the state of the checkbox
      log.log('Previous Came here')
      setCheck(!check);
      log.log(check, id, qrId, { previousResponse });
      if (check) {
        // If the ID is not present, add it to both options and ids
        if (!previousResponse?.response_options_ids.includes(id)) {
          updatedResponseOptions = [...previousResponse?.response_options, { id }];
          updatedResponseOptionsIds = [...previousResponse?.response_options_ids, id];
        } else {
          // If the ID is already present, remove it from both options and ids
          updatedResponseOptions = previousResponse?.response_options.filter(item => item.id !== id);
          updatedResponseOptionsIds = previousResponse?.response_options_ids.filter(itemId => itemId !== id);
        }
      } else {
        // If unchecking, remove the ID from both options and ids
        //updatedResponseOptions = [...previousResponse?.response_options, { id }];
        updatedResponseOptions = [...(previousResponse?.response_options ?? []), id];
        updatedResponseOptionsIds = [...previousResponse?.response_options_ids ?? [], id];
      }
      log.log({ courseId, question, id, 'null': "null", qrId, check });
      const response = await actions.addQuestionResponsesRequest(courseId, question, id, null, qrId, !check);
      // log.log(response)
      if (response) {
        setQRId(response.id);
      }
    }

    // Ensure updatedResp has the same structure as the first previousResponse
    const updatedResp = {
      ...previousResponse,
      response_options: updatedResponseOptions,
      response_options_ids: updatedResponseOptionsIds,
      id: question?.id
    };

    // Update the previous response with the updated response options
    log.log("inside : ", updatedResp);
    updateResponse(updatedResp);
  };




  const isOptionCorrect = answerOptions.includes(id);
  const isOptionSelected = previousResponse?.response_options_ids?.includes(id);
  log.log(previousResponse.response_option_ids, " now", isOptionCorrect, isOptionSelected);
  switch (questionType) {
    case "S":
      return (
        <Col xs={12} 
          className={`option ${disable ? "disabled" : ""}`} style={Eval ? { border: isOptionCorrect ? '2px solid green' : (isOptionSelected ? '2px solid red' : ''), backgroundColor: isOptionCorrect ? '#a5f1d9' : (isOptionSelected ? '' : '') } : {}} 
          onClick={() => storeResponses(id)}
        >
          <Form.Check
            type="radio"
            id={id}
            label={text}
            name={questionId}
            // defaultChecked={check}
            checked={isOptionSelected}
            disabled={disable}
          />
          {log.log(id, check, "mcq", questionId)}
        </Col>
      );
    case "M":
      return (
        <Col xs={12} className={`option ${disable ? "disabled" : ""}`} style={Eval ? { border: isOptionCorrect ? '2px solid green' : (isOptionSelected ? '2px solid red' : ''), backgroundColor: isOptionCorrect ? '#b9eddd' : (isOptionSelected ? '' : '') } : {}} onClick={() => storeResponses(id)}>
          <Form.Check
            type="checkbox"
            id={id}
            label={text}
            name={questionId}
            //defaultChecked={check}
            checked={isOptionSelected}
            // checked={previousResponse.response_options ? previousResponse.response_options.find(item => item.id === id) : false}
            disabled={disable}
          />
        </Col>
      );
    default:
      return (
        <Row>
          <div>Question Option issue</div>
        </Row>
      );
  }
};

const Options = ({
  courseId,
  question,
  otherLabID,
  questionId,
  options,
  questionType,
  previousResponse,
  updateResponse,
  disable,
  Eval
}) => {

  const [questionResponseId, setQuestionResponseId] = useState(null);

  useEffect(() => {
    log.log("previous Response is", { qrId: previousResponse })
    if (previousResponse && !questionResponseId) {
      setQuestionResponseId(previousResponse.id)
    }
  }, [previousResponse]);

  const handleUpdateResponse = (updatedOptions) => {
    // Update the previousResponse object with the updated optionsresponse_options_ids: updatedResponseOptionsIds
    //const updatedresponse = { ...previousResponse, response_options: updatedOptions };
    log.log(" here --- > ", {qrId: updatedOptions})
    updateResponse(updatedOptions);
  };

  return (
    <Row className="options">
      {options.map((option) => (
        <Option
          courseId={courseId}
          question={question}
          otherLabId={otherLabID}
          questionId={questionId}
          option={option}
          questionType={questionType}
          previousResponse={previousResponse}
          qrId={questionResponseId}
          setQRId={(id) => setQuestionResponseId(id)}
          // updateResponse={updateResponse}
          updateResponse={handleUpdateResponse}
          disable={disable}
          Eval={Eval}
        />
      ))}
    </Row>
  );
};

export default Options;
